import { createFileRoute } from '@tanstack/react-router'
import { TimeOffPage } from '@/features/hr/ui/time-off-page'

export const Route = createFileRoute('/_authenticated/hr/time-off/')({
	component: TimeOffPage,
})
